import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "store/baseQueryConfig ";

export const avoirApi = createApi({
  reducerPath: "avoirApi",
  baseQuery: baseQueryConfig,
  tagTypes: ["AVOIR"],
  endpoints: (builder) => ({
    // GET all avoirs by companyId
    getAvoirs: builder.query({
      query: (companyId) => ({
        url: `credit-note/companyId/${companyId}`,
        method: "GET",
      }),
      providesTags: ["AVOIR"],
    }),

    // POST to create a new avoir (credit note)
    createAvoir: builder.mutation({
      query: (newCreditNote) => ({
        url: "credit-note",
        method: "POST",
        body: newCreditNote,
      }),
      invalidatesTags: ["AVOIR"],
    }),

    // PATCH to update an avoir (by companyId and avoirId)
    updateAvoir: builder.mutation({
      query: ({ companyId, id, ...fields }) => ({
        url: `credit-note/companyId/${companyId}/avoir/${id}`,
        method: "PATCH",
        body: fields,
      }),
      invalidatesTags: ["AVOIR"],
    }),
    getAvoirByInvoiceNum: builder.query({
      query: ({ companyId, invoiceId }) => ({
        url: `credit-note/companyId/${companyId}/invoiceId/${invoiceId}`,
        method: "GET",
      }),
      providesTags: ["AVOIR"],
    }),
  }),
});

// Export hooks
export const {
  useGetAvoirsQuery,
  useCreateAvoirMutation,
  useUpdateAvoirMutation,

  useGetAvoirByInvoiceNumQuery,
} = avoirApi;

export default avoirApi;
